import React from 'react'
import { path, prop } from 'ramda'
import Typography from '@mui/material/Typography'
import { SearchField } from 'storfox-query-builder'

import * as API from '~/constants/api'

const getOptionValue = value => {
  if (value) {
    const id = prop('id', value)
    const guid = prop('guid', value)
    const name = prop('name', value)
    const companyName = path(['company', 'name'], value)

    return { id, guid, name, companyName }
  }

  return null
}

function WarehouseSearchField (props) {
  return (
    <SearchField
      label="Warehouse"
      api={API.AUTOMATION_RULE_WAREHOUSE_LIST}
      primaryKey="guid"
      {...props}
      getOptionValue={getOptionValue}
      renderOption={(props, option) => (
        <li {...props} style={{ display: 'block' }}>
          <Typography>
            {option.name}
          </Typography>
          <Typography variant="body2">
            {option.companyName}
          </Typography>
        </li>
      )}
    />
  )
}

export default WarehouseSearchField
